import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sc_side = _resolveComponent("sc-side")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!
  const _component_sc_windows = _resolveComponent("sc-windows")!

  return (_openBlock(), _createBlock(_component_a_layout, { class: "sc-layout-container" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout, null, {
        default: _withCtx(() => [
          _createVNode(_component_sc_side),
          _createVNode(_component_a_layout, { style: {"padding":"0 24px 24px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_a_layout_content, { class: "content" }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_component_router_view, {
                    key: _ctx.$route.path
                  }))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_sc_windows, { ref: "windows" }, null, 512)
    ]),
    _: 1
  }))
}